import axios from 'axios';

const bURL = process.env.REACT_APP_API_URL || '';

const BASE_URL = `${bURL}/api`;

export default axios.create({
    baseURL: BASE_URL
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    // headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});
